import { CheckCircle2, Clock, XCircle, Send, Ban } from "lucide-react";

// Giden fatura (e-Fatura / e-Arşiv) QNB durumu — e-İrsaliye listesindeki statusOf ile aynı yapı
export const invoiceQnbStatus = (inv) => {
  const q = inv?.qnb || {};
  const st = q.status || {};
  const emerald = { cls: "bg-emerald-600 text-white border-emerald-600", stripe: "bg-emerald-500" };
  const sky = { cls: "bg-sky-100 text-sky-700 border-sky-200", stripe: "bg-sky-500" };
  const red = { cls: "bg-red-100 text-red-700 border-red-200", stripe: "bg-red-500" };
  if (q.cancelled) return { key: "iptal", label: "İptal edildi", icon: Ban, sent: true, ...red };
  if (q.success === false || st.durum === 2) return { key: "hata", label: "Hata", icon: XCircle, sent: !!q.ettn, ...red };
  if (!q.success) return { key: "taslak", label: "Taslak", icon: Clock, sent: false, cls: "bg-muted text-muted-foreground border-border", stripe: "bg-amber-400" };
  if (q.objected) return { key: "red", label: "İtiraz bildirildi", icon: XCircle, sent: true, cls: "bg-orange-100 text-orange-800 border-orange-200", stripe: "bg-orange-500" };
  if (q.imported) return { key: "ulasti", label: q.channel === "efatura" ? "e-Fatura kesildi (Portal)" : "e-Arşiv oluşturuldu (Portal)", icon: CheckCircle2, sent: true, imported: true, ...emerald };
  if (q.channel === "earsiv") {
    if (q.draft) return { key: "gonderildi", label: "e-Arşiv taslağı (QNB)", icon: Send, sent: true, ...sky };
    return { key: "ulasti", label: "e-Arşiv oluşturuldu", icon: CheckCircle2, sent: true, ...emerald };
  }
  if (st.yanit_durumu === 1) return { key: "red", label: "Alıcı RED etti", icon: XCircle, sent: true, cls: "bg-orange-100 text-orange-800 border-orange-200", stripe: "bg-orange-500" };
  if (st.yanit_durumu === 2) return { key: "ulasti", label: "Alıcı KABUL etti", icon: CheckCircle2, sent: true, ...emerald };
  if (st.ulasti || st.gonderim_durumu === 4) {
    const waiting = q.profile === "TICARIFATURA" && !q.final;
    return { key: "ulasti", label: waiting ? "Ulaştı · yanıt bekleniyor" : "Alıcıya ulaştı", icon: CheckCircle2, sent: true, waiting, ...emerald };
  }
  return { key: "gonderildi", label: "QNB/GİB işliyor", icon: Send, sent: true, processing: true, ...sky };
};

export const INVOICE_STATUS_FILTERS = [["all", "Tümü"], ["gonderildi", "İşleniyor"], ["ulasti", "Ulaştı"], ["red", "Red / İtiraz"], ["iptal", "İptal"], ["hata", "Hata"]];

// Satır sonundaki pasif rozet metni (e-İrsaliye: "Gönderildi ✓")
export const sentBadgeText = (st) => {
  if (st.processing) return "Kesildi · işleniyor";
  if (st.waiting) return "Kesildi · yanıt bekleniyor";
  if (st.key === "ulasti") return "Kesildi ✓";
  return st.label;
};
export const sentBadgeCls = (st) =>
  st.key === "ulasti" ? "bg-emerald-600 text-white" : st.key === "gonderildi" ? "bg-sky-100 text-sky-800" : st.key === "red" ? "bg-orange-100 text-orange-800" : "bg-red-100 text-red-700";
